import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const components = {
  h1: ({ node, ...props }) => <h3 className="text-lg font-semibold text-zinc-900 mt-5 first:mt-0 mb-2" {...props} />,
  h2: ({ node, ...props }) => <h3 className="text-base font-semibold text-zinc-900 mt-5 first:mt-0 mb-2" {...props} />,
  h3: ({ node, ...props }) => <h4 className="text-sm font-semibold text-zinc-800 mt-4 first:mt-0 mb-1.5" {...props} />,
  h4: ({ node, ...props }) => <h5 className="text-sm font-semibold text-zinc-700 mt-3 first:mt-0 mb-1" {...props} />,
  p: ({ node, ...props }) => <p className="text-sm leading-relaxed text-zinc-700 mb-3 last:mb-0" {...props} />,
  ul: ({ node, ...props }) => <ul className="list-disc pl-5 space-y-1 mb-3 text-sm text-zinc-700" {...props} />,
  ol: ({ node, ...props }) => <ol className="list-decimal pl-5 space-y-1 mb-3 text-sm text-zinc-700" {...props} />,
  li: ({ node, ...props }) => <li className="leading-relaxed" {...props} />,
  strong: ({ node, ...props }) => <strong className="font-semibold text-zinc-900" {...props} />,
  em: ({ node, ...props }) => <em className="italic" {...props} />,
  a: ({ node, ...props }) => (
    <a className="text-emerald-700 underline underline-offset-2" target="_blank" rel="noreferrer" {...props} />
  ),
  hr: () => <hr className="my-4 border-zinc-200" />,
  blockquote: ({ node, ...props }) => (
    <blockquote className="border-l-2 border-emerald-600 pl-3 italic text-zinc-600 mb-3" {...props} />
  ),
  code: ({ node, inline, ...props }) =>
    inline ? (
      <code className="rounded bg-zinc-100 px-1 py-0.5 text-[0.8em] text-zinc-800" {...props} />
    ) : (
      <code className="block overflow-x-auto rounded bg-zinc-900 p-3 text-xs text-zinc-100 mb-3" {...props} />
    ),
  table: ({ node, ...props }) => (
    <div className="overflow-x-auto mb-3">
      <table className="w-full text-sm border-collapse" {...props} />
    </div>
  ),
  th: ({ node, ...props }) => (
    <th className="border-b border-zinc-300 px-2 py-1.5 text-left font-semibold text-zinc-800" {...props} />
  ),
  td: ({ node, ...props }) => <td className="border-b border-zinc-100 px-2 py-1.5 text-zinc-700" {...props} />,
};

export const Markdown = ({ content, className = '', components: overrides }) => (
  <div className={className}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={overrides ? { ...components, ...overrides } : components}>
      {content || ''}
    </ReactMarkdown>
  </div>
);

export default Markdown;
